import React from 'react';

// Local replacement for @appucations/core atoms/span (package no longer
// available). A thin, prop-transparent <span> wrapper.
const Span = ({ children, ...rest }) => <span {...rest}>{children}</span>;

export default Span;
